import getDISInstance from './disInstance';

const instance = getDISInstance();

export const uploadImage = (body) => {
  const url = '/upload/file';
  return instance
    .post(url, body)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
};
